import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { AuthContext } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Logo from '../common/Logo';
import Footer from '../layout/Footer';

const { FiMail, FiLock, FiLogIn } = FiIcons;

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const success = await login(email, password);
    if (!success) {
      setError('Invalid email or password. Please try again.');
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gray-900 text-white">
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 p-4">
        <motion.div
          className="w-full max-w-md"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="text-center mb-8" variants={itemVariants}>
            <div className="inline-block">
              <Logo />
            </div>
            <h1 className="text-4xl font-bold mt-4">Welcome Back</h1>
            <p className="text-gray-400">Sign in to continue to ReferBridge</p>
          </motion.div>

          <motion.div
            className="auth-card"
            variants={itemVariants}
          >
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="auth-label" htmlFor="email">
                  Email Address
                </label>
                <div className="relative">
                  <SafeIcon icon={FiMail} className="auth-icon" />
                  <input
                    id="email"
                    type="email"
                    className="auth-input"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div>
                <label className="auth-label" htmlFor="password">
                  Password
                </label>
                <div className="relative">
                  <SafeIcon icon={FiLock} className="auth-icon" />
                  <input
                    id="password"
                    type="password"
                    className="auth-input"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              {error && (
                <motion.p
                  className="text-red-400 text-sm mt-4 text-center"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  {error}
                </motion.p>
              )}

              <div className="mt-6">
                <motion.button
                  type="submit"
                  className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary focus:ring-offset-gray-900 transition-colors"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <SafeIcon icon={FiLogIn} className="mr-2" />
                  Sign In
                </motion.button>
              </div>
            </form>
            <div className="mt-6 text-center">
              <a href="#" className="text-sm text-gray-400 hover:text-white">
                Forgot your password?
              </a>
            </div>
          </motion.div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginPage;